export default function (app) {
  app.factory('klRatePlanService', [
    '$q',
    '$state',
    '$http',
    'klNotificationService',
    'klTranslationService',
    '$rootScope',
    'config',
    function ($q, $state, $http, NotificationService, TranslationService, $rootScope, config) {
      let _ratePlanCache = {};

      $rootScope.$on('$translateChangeStart', (event, data) => {
        if (data.language === TranslationService.getLanguage()) return;
        _ratePlanCache = {};
      });

      function getRatePlan(ratePlanId) {
        if (!_ratePlanCache[ratePlanId]) {
          _ratePlanCache[ratePlanId] = $http.get(`/webshop-api/productRatePlanObjects/${ratePlanId}`)
            .then(response => response.data)
            .then(ratePlan =>
              $http.get(`/webshop-api/productRatePlanChargeObjects/${ratePlanId}`)
                .then(response => response.data)
                .then(productRatePlanCharges => Object.assign(ratePlan, { productRatePlanCharges }))
            );
        }

        return _ratePlanCache[ratePlanId];
      }

      function addDefaultQuantity(ratePlanItem) {
        let ratePlan = ratePlanItem.ratePlan;
        let ratePlanCharges = ratePlan.productRatePlanCharges;
        if (!ratePlanItem.quantity) ratePlanItem.quantity = 1;
        for (let j = 0; j < ratePlanCharges.length; j++) {
          let charge = ratePlanCharges[j];
          if (!!charge.uom && charge.chargeType != 'Usage' && !!charge.defaultQuantity) {
            charge.quantity = ratePlanItem.quantity;
          } else if (!!charge.defaultQuantity) {
            charge.quantity = charge.defaultQuantity;
            ratePlanItem.quantity = charge.quantity;
          } else {
            charge.quantity = 1;
          }
        }
        return ratePlanItem;
      }

      function updateCharges(ratePlans) {
        if (!ratePlans) return;
        if (!Array.isArray(ratePlans)) ratePlans = [ratePlans];
        for (let i = 0; i < ratePlans.length; i++) {
          let ratePlan = ratePlans[i].ratePlan;
          let ratePlanCharges = ratePlan.productRatePlanCharges;
          for (let j = 0; j < ratePlanCharges.length; j++) {
            let charge = ratePlanCharges[j];
            if (!!charge.uom && charge.chargeType != 'Usage') charge.quantity = ratePlans[i].quantity;
          }
        }
        return ratePlans;
      }

      function calculatePrices(ratePlans, account) {
        if (!ratePlans) return;
        if (!Array.isArray(ratePlans)) ratePlans = [ratePlans];
        let data = { productRatePlans: ratePlans };
        if (!!account) data.account = account;
        return $http
          .post(`/api/subscription/preview`, data)
          .then((response) => response.data)
          .catch((e) => {
            NotificationService.putError('auth', "The tax-engine couldn't calculate the correct tax amount for your address. Please reach out to support@enscape3d.com!");
            return data;
          });
      }

      function decorateRatePlans(ratePlans) {
        if (!ratePlans) return;
        for (let i = 0; i < ratePlans.length; i++) {
          let ratePlan = ratePlans[i].ratePlan;
          let prices = {};
          let ratePlanCharges = ratePlan.productRatePlanCharges;
          for (let j = 0; j < ratePlanCharges.length; j++) {
            let charge = ratePlanCharges[j];
            if (charge.chargeType == 'OneTime') addPrice(prices, 'OneTime', charge);
            if (charge.chargeType == 'Recurring') addPrice(prices, charge.billingPeriod, charge);
            if (!!charge.uom && charge.chargeType != 'Usage') ratePlans[i].uom = charge.uom;
          }
          ratePlans[i].prices = prices;
        }
        return ratePlans;
      }

      function getBillingPeriods(ratePlans) {
        let billingPeriods = [];
        for (let i = 0; i < ratePlans.length; i++) {
          let ratePlan = ratePlans[i].ratePlan;
          let ratePlanCharges = ratePlan.productRatePlanCharges;
          for (let j = 0; j < ratePlanCharges.length; j++) {
            let charge = ratePlanCharges[j];
            let chargeType;
            if (charge.chargeType == 'OneTime') chargeType = 'OneTime';
            if (charge.chargeType == 'Recurring') chargeType = charge.billingPeriod;

            if (!!chargeType && billingPeriods.indexOf(chargeType) == -1) billingPeriods.push(chargeType);
          }
        }
        return billingPeriods;
      }

      function addPrice(prices, key, charge) {
        if (!prices[key]) {
          prices[key] = {
            netto: 0,
            brutto: 0,
            tax: 0,
          };
        }
        if (charge.tax) prices[key].tax += parseFloat(charge.tax);
        if (charge.price) prices[key].netto += parseFloat(charge.price);
        prices[key].brutto = prices[key].netto + prices[key].tax;
      }

      return {
        addDefaultQuantity,
        getRatePlan,
        getBillingPeriods,
        updateCharges,
        calculatePrices,
        decorateRatePlans,
      };
    },
  ]);
}
